import logo from './logo.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="Title">
        <img src={logo} className="Logo" alt="logo" />
        <div>
          <a href="/">
            <h1 className="Name">문상준 치과의원</h1>
          </a>
        </div>
      </header>

      <div className="Subtitle">
        <h2 className="Goal">진심으로 임하는 가족 같은 치과</h2>
        <div className="Actions">
          <a className="ActionButton" href="https://pf.kakao.com/_xmUxlij/chat" target="_blank" rel="noopener noreferrer">
            카카오톡 문의
          </a>
          <a className="ActionButton secondary" href="https://talk.naver.com/W40QBB" target="_blank" rel="noopener noreferrer">
            네이버 톡톡 문의
          </a>
        </div>
      </div>

      <main className="Content">
        <section className="Card Hours">
          <div className="SectionHeader">
            <h2>진료 시간</h2>
          </div>
          <ul className="List">
            <li>월 · 화 · 수 · 금 : 10:00 - 18:30</li>
            <li>목 : 14:00 - 20:30</li>
            <li>토 : 10:00 - 13:30</li>
            <li className="Hint">* 점심시간 13:00 - 14:00</li>
          </ul>
        </section>

        <section className="Card Location">
          <div className="SectionHeader">
            <h2>오시는 길</h2>
          </div>
          <p className="Address">인천 남동구 간석 4동 894-4 제일코아 2층</p>
          <div className="Links">
            <a className="LinkButton" href="https://naver.me/xGXtZtDV" target="_blank" rel="noopener noreferrer">
              네이버 지도 보기
            </a>
            <a className="LinkButton" href="https://kko.to/51dv4iN0p" target="_blank" rel="noopener noreferrer">
              카카오 지도 보기
            </a>
          </div>
        </section>
      </main>

      <footer className="Footer">
        <span>대표 : 문상준</span>
        <span>전화번호 : 032-432-2875</span>
      </footer>
    </div>
  );
}

export default App;
